// Tooltip style enum
enum TooltipStyle {
	Compact,
	Extended,
}

export default TooltipStyle;
